"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ViewPhotosDialog;
var _react = _interopRequireWildcard(require("react"));
var _DialogBox = _interopRequireDefault(require("../DialogBox/DialogBox"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _reactMultiCarousel = _interopRequireDefault(require("react-multi-carousel"));
require("react-multi-carousel/lib/styles.css");
var _material = require("@mui/material");
require("./styles.scss");
var _BusySpinner = _interopRequireDefault(require("../BusySpinner"));
function ViewPhotosDialog(props) {
  const {
    onClose,
    open,
    photos,
    initialSelectedSlide,
    nextButtonLabel,
    prevButtonLabel,
    title,
    numbered,
    dots
  } = props;
  const [isPreviousDisabled, setIsPreviousDisabled] = (0, _react.useState)(false);
  const [isNextDisabled, setIsNextDisabled] = (0, _react.useState)(false);
  const [isLoading, setIsLoading] = (0, _react.useState)([]);
  const [selectedSlide, setSelectedSlide] = (0, _react.useState)(initialSelectedSlide);
  const myCarousel = (0, _react.useRef)(null);
  const responsive = {
    mobile: {
      breakpoint: {
        max: 4000,
        min: 0
      },
      items: 1
    }
  };
  const handleChange = (0, _react.useCallback)(args => {
    if (myCarousel.current) {
      if (myCarousel.current.state.currentSlide + 1 >= photos.length) {
        setIsNextDisabled(true);
      } else {
        setIsNextDisabled(false);
      }
      if (myCarousel.current.state.currentSlide - 1 < 0) {
        setIsPreviousDisabled(true);
      } else {
        setIsPreviousDisabled(false);
      }
      if (args !== undefined) {
        // if we came from the carousel component's call of handleChange, do the right thing
        // don't set this slide if we came from useEffect on open
        setSelectedSlide(myCarousel.current.state.currentSlide);
      } else {
        // we need to reinitialize to last state
        if (selectedSlide === initialSelectedSlide) {
          // explicitly go to slide, the useEffect won't be triggered
          myCarousel.current.goToSlide(selectedSlide);
        }
      }
    }
  }, [photos.length, selectedSlide, initialSelectedSlide, selectedSlide]);
  (0, _react.useEffect)(() => {
    setIsLoading(new Array(photos.length).fill(true));
  }, [photos.length]);
  (0, _react.useEffect)(() => {
    setSelectedSlide(initialSelectedSlide);
  }, [initialSelectedSlide]);
  (0, _react.useEffect)(() => {
    handleChange();
  }, [open, handleChange]);
  (0, _react.useEffect)(() => {
    if (myCarousel.current) {
      myCarousel.current.goToSlide(selectedSlide);
    }
  }, [selectedSlide]);
  const finishLoading = index => {
    const newIsLoading = [...isLoading];
    newIsLoading[index] = false;
    setIsLoading(newIsLoading);
  };
  return /*#__PURE__*/_react.default.createElement(_DialogBox.default, {
    onClose: onClose,
    open: open,
    title: title,
    size: "large",
    scrolled: true,
    middleButtons: [/*#__PURE__*/_react.default.createElement(_Button.default, {
      label: prevButtonLabel,
      priority: "secondary",
      onClick: () => setSelectedSlide(slide => Math.max(0, slide - 1)),
      key: "button-1",
      disabled: isPreviousDisabled,
      icon: "caretLeft"
    }), /*#__PURE__*/_react.default.createElement(_Button.default, {
      label: nextButtonLabel,
      onClick: () => setSelectedSlide(slide => Math.min(photos.length - 1, slide + 1)),
      key: "button-2",
      disabled: isNextDisabled,
      rightIcon: "caretRight"
    })]
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: {
      '& .react-multi-carousel-list': {
        paddingBottom: '20px'
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_reactMultiCarousel.default, {
    responsive: responsive,
    ref: myCarousel,
    showDots: dots !== null && dots !== void 0 ? dots : true,
    arrows: false,
    ssr: true,
    afterChange: handleChange
  }, photos.map((p, i) => /*#__PURE__*/_react.default.createElement("div", {
    key: "photo-".concat(i, "-container"),
    className: "view-photos-dialog-container"
  }, isLoading[i] ? /*#__PURE__*/_react.default.createElement(_BusySpinner.default, {
    noBackground: true
  }) : undefined, /*#__PURE__*/_react.default.createElement("a", {
    href: p.url,
    target: "blank"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "view-photos-dialog-image",
    src: p.url,
    alt: p.alt,
    onLoad: () => finishLoading(i)
  }))))), numbered ? /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "photo-numbering"
  }, "".concat(selectedSlide + 1, "/").concat(photos.length)) : undefined, photos[selectedSlide] && photos[selectedSlide].decoration));
}